export const LISTENER_ORDERS_CARD_ID_CHANNEL = "LISTENER_ORDERS_CARD_ID_CHANNEL"
export const LISTENER_ORDERS_CARD_ID_CHANNEL_SUCCESS = "LISTENER_ORDERS_CARD_ID_CHANNEL_SUCCESS"

export const LISTENER_ORDERS_CHANNEL_BY_ID_COMPANY = "LISTENER_ORDERS_CHANNEL_BY_ID_COMPANY"
export const LISTENER_ORDERS_CHANNEL_BY_ID_COMPANY_SUCCESS = "LISTENER_ORDERS_CHANNEL_BY_ID_COMPANY_SUCCESS"

export const ORDERS_CHANNEL_ERROR = "FIND_OR_EDIT_ORDERS_CHANNEL_ERROR"
